const state = {
  isProcessingResyncRunning: false,
  isProcessingResyncEnded: false,
  isProcessingResyncFailed: false,
  totalCount: 0,
  processedCount: 0,
  isResyncClosed: true,
};

const getters = {
  isProcessingResyncRunning(state) {
    return state.isProcessingResyncRunning;
  },
  isProcessingResyncEnded(state) {
    return state.isProcessingResyncEnded;
  },
  isProcessingResyncFailed(state) {
    return state.isProcessingResyncFailed;
  },
  totalCount(state) {
    return state.totalCount;
  },
  processedCount(state) {
    return state.processedCount;
  },
  isResyncClosed(state) {
    return state.isResyncClosed;
  },
};

const actions = {
  startResyncProcess({ commit }) {
    commit('setStartResyncStatus');
  },
  updateResyncStatus({ commit }, statusData) {
    commit('setResyncStatus', statusData);
  },

  closeResyncProccess({ commit }) {
    commit('resetResyncState');
  },
};

const mutations = {
  setStartResyncStatus(state) {
    state.isProcessingResyncRunning = true;
    state.isProcessingResyncEnded = false;
    state.isProcessingResyncFailed = false;
    state.totalCount = 0;
    state.processedCount = 0;
    state.isResyncClosed = false;
  },

  setResyncStatus(state, { running, ended, failed, totalCount, processedCount, isResyncClosed }) {
    state.isProcessingResyncRunning = running;
    state.isProcessingResyncEnded = ended;
    state.isProcessingResyncFailed = failed;
    state.totalCount = totalCount || 0;
    state.processedCount = processedCount || 0;
    state.isResyncClosed = isResyncClosed || false;
  },

  resetResyncState(state) {
    state.isProcessingResyncRunning = false;
    state.isProcessingResyncEnded = false;
    state.isProcessingResyncFailed = false;
    state.totalCount = 0;
    state.processedCount = 0;
    state.isResyncClosed = true;
  },
};

export const ActivitySessionResyncStore = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
